import React from 'react'
import { Text, Flex } from 'pcln-design-system'

const SignedOutHeaderText = ({ inDollars, inPercent }) => {
  const savePercentText = `That's ${inPercent}% off the retail price`
  return (
    <>
      {inDollars > 0 && inPercent > 0 ? (
        <Flex>
          <Text fontWeight='bold'>Save ${inDollars}!</Text>

          <Text fontWeight='regular' ml={2}>
            {savePercentText}
          </Text>
        </Flex>
      ) : null}
    </>
  )
}

export { SignedOutHeaderText }
